export default __webpack_public_path__ + "static/media/appstore-button.fea8488a.png";